import React from 'react';
import Signup from '../components/Signup';

const SignupPage = () => {
  return <Signup />;
};

export default SignupPage;














